<div>
  <a class="id37-link" (click)="goToFriend()">{{friendName}}</a>
  <span>{{messagePartA}}</span>
</div>
